import type { CustomizeSaleType } from '@fff-web/sdk-types';

export const BOX_SECTION_ANCHOR_ID = {
  beauty_box: 'beauty-edit-box',
  pup_box: 'pup-box',
} as const satisfies Partial<Record<CustomizeSaleType, string>>;

export type BoxSectionAnchorId = (typeof BOX_SECTION_ANCHOR_ID)[keyof typeof BOX_SECTION_ANCHOR_ID];

export const resolveBoxSectionAnchorId = (
  customizeSaleType: string | undefined | null,
): BoxSectionAnchorId | undefined => {
  if (!customizeSaleType) return undefined;
  return BOX_SECTION_ANCHOR_ID[customizeSaleType as keyof typeof BOX_SECTION_ANCHOR_ID];
};
